var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationsEmptyLatest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 56C48.9543 56 40 47.2696 40 36.5C40 25.7304 48.9543 17 60 17C71.0457 17 80 25.7304 80 36.5C80 40.2508 78.9139 43.7542 77.0315 46.7277C76.9493 46.8575 76.9291 47.0175 76.9788 47.163L79.6764 55.0536C79.8097 55.4435 79.4407 55.8182 79.0488 55.6909L70.9205 53.0492C70.7807 53.0037 70.6282 53.0224 70.5023 53.0983C67.4499 54.9382 63.8522 56 60 56Z",
    fill: "url(#paint0_linear_240_6)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_240_6)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 56C47.464 56 60 43.464 60 28C60 12.536 47.464 0 32 0C16.536 0 4 12.536 4 28C4 33.4249 5.5428 38.4896 8.21357 42.779C8.29302 42.9066 8.31238 43.0629 8.26484 43.2055L4.31623 55.0513C4.18593 55.4422 4.5578 55.8141 4.94868 55.6838L16.7945 51.7352C16.9371 51.6876 17.0934 51.707 17.221 51.7864C21.5104 54.4572 26.5751 56 32 56Z",
    fill: "url(#paint1_linear_240_6)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0.25C47.3259 0.25 59.75 12.6741 59.75 28C59.75 43.3259 47.3259 55.75 32 55.75C26.6232 55.75 21.6044 54.2209 17.3535 51.5742C17.1638 51.4561 16.93 51.4268 16.7158 51.498L4.86914 55.4463C4.67394 55.5111 4.48894 55.3261 4.55371 55.1309L8.50195 43.2842C8.57325 43.07 8.54392 42.8362 8.42578 42.6465C5.77909 38.3956 4.25 33.3768 4.25 28C4.25 12.6741 16.6741 0.25 32 0.25Z",
    stroke: "url(#paint2_linear_240_6)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_240_6",
    x: 0,
    y: -4,
    width: 64,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_240_6_clip_path",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 56C47.464 56 60 43.464 60 28C60 12.536 47.464 0 32 0C16.536 0 4 12.536 4 28C4 33.4249 5.5428 38.4896 8.21357 42.779C8.29302 42.9066 8.31238 43.0629 8.26484 43.2055L4.31623 55.0513C4.18593 55.4422 4.5578 55.8141 4.94868 55.6838L16.7945 51.7352C16.9371 51.6876 17.0934 51.707 17.221 51.7864C21.5104 54.4572 26.5751 56 32 56Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_6",
    x1: 80,
    y1: 17,
    x2: 41.0125,
    y2: 56.9872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3813C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_6",
    x1: -4.4,
    y1: 61.6,
    x2: 60,
    y2: -4.79817e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_6",
    x1: 54.4,
    y1: 61.6,
    x2: 4,
    y2: 1.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationsEmptyLatest);
export default __webpack_public_path__ + "static/media/ConversationsEmptyLatest.41af080e306459080ccacf47c207977d.svg";
export { ForwardRef as ReactComponent };